import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=b0a4b374&scoped=true&"
import script from "./SupportList.vue?vue&type=script&lang=js&"
export * from "./SupportList.vue?vue&type=script&lang=js&"
import style0 from "./SupportList.vue?vue&type=style&index=0&id=b0a4b374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a4b374",
  null
  
)

export default component.exports